import * as React from "react";
import { FormattedAuditLogEntityChange } from "./formattedAuditLog";

interface AuditLogChangeProps {
  auditLogChange: FormattedAuditLogEntityChange;
}

const AuditLogChangeComponent: React.SFC<AuditLogChangeProps> = ({
  auditLogChange
}) => (
  <div className="AuditLogChange">
    <div className="AuditLogChange__primary-info">
      <div className="AuditLogChange__info">
        <div className="AuditLogChange__type">
          {auditLogChange.auditLogType}
        </div>
      </div>
      <div className="AuditLogChange__date-container">
        <div className="AuditLogChange__date">{auditLogChange.timestamp}</div>
      </div>
    </div>
    <div className="AuditLogChange__info">
      <span className="AuditLogChange__message">
        {auditLogChange.logMessage}
      </span>
    </div>
  </div>
);

export default AuditLogChangeComponent;



// WEBPACK FOOTER //
// ./src/auditLog/AuditLogChange.tsx